module.exports = __webpack_public_path__ + "images/2cb9d0d365a24b2b04c7f2b986240fa77de60026bf497ecb5b2779bfac4dfe6b.svg";